import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SocialSidebar from './SocialSidebar';

const Layout = ({ children, user, currentView, onNavigate, onLogout }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header
        user={user}
        currentView={currentView}
        onNavigate={onNavigate}
        onLogout={onLogout}
      />

      {/* Main Content */}
      <main className="flex-1 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {children}
        </div>
      </main>

      {/* Sticky Social Media Sidebar */}
      <SocialSidebar />

      {/* Footer */}
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default Layout;
